import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import { getFormattedContentData } from '../../services/content/index'
import { H1 } from '../Heading/index'
import RowV3 from '../Row.v3/index'
import { STYLES } from '../Row.v3/utils'
import TileV2Graphql from '../Tile.v2/Tile.v2Graphql/index'
import LoadMore from '../LoadMore/index'
// import MyLibraryTooltip from './MyLibraryTooltip'

const MyLibraryPurchasesVideos = (props) => {
  const {
    pageState,
    contentList,
    fetchMore,
    loading,
    count = 0,
    totalCount = 0,
  } = props

  const renderItem = (item, index) => {
    const tileData = getFormattedContentData(item)

    return (
      <TileV2Graphql
        key={index}
        data={tileData}
        adminTitle="My Library"
        index={index}
        uiLocation="My Library"
      />
    )
  }

  return (
    <div className="my-library__content">
      <header className="my-library__playlist-header my-library__playlist-header--no-control">
        <H1>{pageState.name}</H1>
      </header>
      {/* temporarily disabled <MyLibraryTooltip /> */}
      <RowV3
        asGrid
        style={STYLES.S12334}
      >
        {contentList.map((item, index) => renderItem(item, index))}
      </RowV3>
      <LoadMore
        onLoadMore={() => fetchMore({
          variables: {
            offset: count,
          },
        })}
        buttonClassName={['my-library__load-more-button', 'button--secondary']}
        currentCount={count}
        totalCount={totalCount}
        processing={loading || !contentList.size}
        infiniteScroll
      />
    </div>
  )
}

MyLibraryPurchasesVideos.propTypes = {
  pageState: PropTypes.object.isRequired,
  contentList: ImmutablePropTypes.list.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  fetchMore: PropTypes.func,
  loading: PropTypes.bool,
  count: PropTypes.number,
  totalCount: PropTypes.number,
}

export default connect(
  (state) => {
    return {
      staticText: state.staticText.getIn(['data', 'myLibraryPage', 'data'], Map()) || Map(),
    }
  },
)(MyLibraryPurchasesVideos)
